import { Capacitor } from '@capacitor/core'

/** 浏览器里是 false。只有装进壳的 WebView 才是 true */
export const isNativeApp = () => Capacitor.isNativePlatform()

/**
 * Android 返回键。
 * 一监听就会关掉插件自带的后退，所以这里自己退历史；栈空了再退出应用。
 * 浏览器里立刻返回，不装监听。
 */
export const bindNativeShell = () => {
	if (!isNativeApp()) return
	void import('@capacitor/app').then(({ App }) => {
		void App.addListener('backButton', ({ canGoBack }) => {
			if (canGoBack) {
				window.history.back()
				return
			}
			void App.exitApp()
		})
	})
}
